<!--
 * @Author: your name
 * @Date: 2021-09-09 10:46:50
 * @LastEditTime: 2021-09-10 18:23:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \taotan_admin\src\views\marriageGetName\babyName\index.vue
-->
<template>
  <div v-loading="pageLoading">
    <div class="babyName-set-content">
      <div class="content" style="margin-bottom: 20px">
        <el-tabs v-model="intitle_id" @tab-click="handleClickTab">
          <el-tab-pane label="智能起名" name="BBQM001"></el-tab-pane>
          <el-tab-pane label="智能测名" name="CM001"></el-tab-pane>
          <el-tab-pane label="生肖运势" name="YS001"></el-tab-pane>
          <el-tab-pane label="八字合婚" name="HP001"></el-tab-pane>
          <el-tab-pane label="紫微斗数" name="ZW001"></el-tab-pane>
          <el-tab-pane label="流年运势" name="YS002"></el-tab-pane>
          <el-tab-pane label="姓名配对" name="HP002"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- S 新增 -->
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item prop="paymentType" label="导航">
                <el-select
                    v-model="params.intitleNavId"
                    clearable
                    filterable
                    placeholder="请选择导航"
                >
                  <el-option v-for="(item,index) in navInfoArray" :key="index" :label="item.name"
                             :value="item.intitleNavId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分类">{{params.intitleTypeName}}</el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="列表图">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                    @click="getPolicy"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>

            <div class="diplay" style="margin-right: 50px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListLang"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 150px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyLang"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 150px; height: 75px; line-height: 80px"
                    @click="getPolicyLang"
                    v-if="isMoerLang"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileLang"
                  @change="getFileLang"
                  accept="image/png,image/jpg"
              />
            </div>

            <div class="diplay">
              <span class="video-label">视频</span>
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListVideo"
                    :key="index"
                    class="slideshow"
                >
                  <div @click="getPolicyVideo">
                    <video
                        width="100%"
                        controls="controls"
                        style="width: 75px; height: 75px; border-radius: 6px"
                    >
                      <source :src="imgUrl" type="video/mp4"/>
                    </video>
                  </div>
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicyVideo"
                    v-if="isMoerVideo"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileVideo"
                  @change="getFileVideo"
                  accept="video/*"
              />
            </div>
          </el-form-item>

          <el-form-item label="轮播图">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListBanner"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyBanner"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicyBanner"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileBanner"
                  @change="getFileBanner"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请填写名称"
                    v-model="params.name"
                    style="width: 234px"
                    maxlength="32"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标识" prop="examId">
                <el-input
                    placeholder="请填写标识"
                    v-model="intitle_id"
                    disabled
                    style="width: 234px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="主题" prop="subject">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请填写主题"
                v-model="params.subject"
                maxlength="200"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="页顶横幅" prop="scroll">
            <el-input placeholder="请填写页顶横幅" v-model="params.scroll" maxlength="32">
            </el-input>
          </el-form-item>

          <el-form-item label="有偿说明" prop="feeDescr">
            <el-input placeholder="请填写有偿说明" v-model="params.feeDescr" maxlength="32">
            </el-input>
          </el-form-item>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="支付价" prop="payPrice">
                <el-input
                    placeholder="请填写支付价"
                    v-model="params.payPrice"
                    style="width: 160px"
                    maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原价" prop="rawPrice">
                <el-input
                    placeholder="请填写原价"
                    v-model="params.rawPrice"
                    style="width: 160px"
                    maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex">
            <el-col :span="6">
              <el-form-item label="VIP免费">
                <el-switch
                    v-model="params.free"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="推荐会员">
                <el-switch
                    v-model="params.recomVip"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="错题集">
                <el-switch
                  v-model="params.resultStatus"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row type="flex">
            <el-col :span="12">
              <template v-if="intitle_id=='BBQM001'">
                <el-form-item label="取名次数" prop="submits">
                  <el-input
                      placeholder="请填写取名次数"
                      v-model="params.submits"
                      style="width: 160px"
                      maxlength="10"
                  ></el-input>
                </el-form-item>
              </template>
              <template v-if="intitle_id=='CM001'">
                <el-form-item label="测名次数" prop="submits">
                  <el-input
                      placeholder="请填写测名次数"
                      v-model="params.submits"
                      style="width: 160px"
                      maxlength="10"
                  ></el-input>
                </el-form-item>
              </template>
              <template v-if="intitle_id=='YS001' || intitle_id=='ZW001' || intitle_id=='YS002' ">
                <el-form-item label="测算次数" prop="submits">
                  <el-input
                      placeholder="请填写测算次数"
                      v-model="params.submits"
                      style="width: 160px"
                      maxlength="10"
                  ></el-input>
                </el-form-item>
              </template>
              <template v-if="intitle_id=='HP001'">
                <el-form-item label="合婚次数" prop="submits">
                  <el-input
                      placeholder="请填写取名次数"
                      v-model="params.submits"
                      style="width: 160px"
                      maxlength="10"
                  ></el-input>
                </el-form-item>
              </template>
              <template v-if="intitle_id=='HP002'">
                <el-form-item label="配对次数" prop="submits">
                  <el-input
                      placeholder="请填写配对次数"
                      v-model="params.submits"
                      style="width: 160px"
                      maxlength="10"
                  ></el-input>
                </el-form-item>
              </template>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购买次数" prop="buys">
                <el-input
                    placeholder="请填写购买次数"
                    v-model="params.buys"
                    style="width: 160px"
                    maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="详情">
              <richText
                  :keyWord="'detail'"
                  :params="params"
                  v-if="richTextMouted"
              ></richText>
            </el-form-item>
          </el-row>
        </el-form>
        <el-row class="contorl-btn">
          <el-button size="medium" v-if="addShow" type="primary" @click="handleEdit"
          >修 改
          </el-button
          >
          <el-button
              v-if="introShow"
              size="medium"
              type="primary"
              @click="jumpNav('babyMameDesSet')"
          >说明设置
          </el-button
          >
          <el-button
              v-if="styleShow"
              size="medium"
              type="primary"
              @click="jumpNav('babyMameStyleSet')"
          >样式设置
          </el-button
          >
        </el-row>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑评测题信息"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
    </el-dialog>
    <!-- 说明列表 -->
    <el-dialog
        title="说明列表"
        :visible.sync="dialogVisibleExplain"
        width="580px;"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-dialog
          width="560px"
          title="新增/编辑说明列表"
          :visible.sync="innerVisible"
          append-to-body
          :close-on-click-modal="false"
      >
        <div class="public-dialog-form">
          <el-form
              ref="explainRuleForm"
              :rules="explainRules"
              :model="explainParams"
              label-width="80px"
          >
            <el-form-item label="类型" prop="introType">
              <el-select
                  v-model="explainParams.introType"
                  clearable
                  filterable
                  placeholder="请选择说明类型"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in explainTypeData"
                    :key="item.enumVal"
                    :label="item.enumName"
                    :value="item.enumVal"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详情">
              <richText
                  v-if="innerVisible"
                  :keyWord="'intro'"
                  :params="explainParams ? explainParams : ''"
              ></richText>
            </el-form-item>
            <el-form-item label="排序" prop="seq">
              <el-input
                  type="text"
                  placeholder="请填写序号"
                  v-model="explainParams.seq"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="public-dialog-footer">
          <el-button size="medium" @click="innerVisible = false"
          >取 消</el-button
          >
          <el-button size="medium" type="primary" @click="handleExplainEdit"
          >提 交</el-button
          >
        </span>
      </el-dialog>

      <el-tabs v-model="activeName" @tab-click="handleClickExplain">
        <el-tab-pane
            v-for="item in explainTypeData"
            :key="item.enumId"
            :label="item.enumName"
            :name="item.enumVal"
        ></el-tab-pane>
      </el-tabs>
      <div class="item-add">
        <el-button size="mini" type="primary" @click="handleClick('explainAdd')"
        >新增 <img src="@assets/images/add-icon.png" alt=""/>
        </el-button>

        <el-table
            ref="multipleTable"
            size="mini"
            :data="explainData"
            border
            style="width: 100%"
            row-key="menuId"
            v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column
              prop="introTypeName"
              label="类型"
              min-width="100"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="examInfoId"
              label="测评题ID"
              width="150"
              align="center"
          >
          </el-table-column>
          <el-table-column prop="seq" label="排序" width="80" align="center">
          </el-table-column>
          <el-table-column prop="ctime" label="时间" width="150" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="150">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleClick('explainEdit', scope.row)"
                  type="success"
                  plain
              >编辑
              </el-button
              >
              <el-button
                  size="mini"
                  @click="handleDeleteexplain(scope.row)"
                  type="danger"
                  plain
                  v-if="numType"
              >删除
              </el-button
              >
              <el-button
                  size="mini"
                  v-else
                  @click="operationShowTime"
                  type="danger"
                  plain
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
        title="关联样式"
        :visible.sync="dialogVisibleStyle"
        width="560px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-form label-width="80px" ref="ruleStyle">
        <el-form-item label="分类">
          <el-input
              type="text"
              placeholder=""
              v-model="paramsClass.class"
              readonly=""
          >
          </el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
              type="text"
              placeholder=""
              v-model="paramsClass.name"
              readonly=""
              style="width: 185px"
          >
          </el-input>
          <span style="margin: 0 12px 0 30px">标识</span>
          <el-input
              type="text"
              placeholder=""
              v-model="paramsClass.iden"
              style="width: 185px"
              readonly=""
          >
          </el-input>
        </el-form-item>

        <el-form-item label="样式">
          <el-tabs
              v-model="paramsClass.styleType"
              @tab-click="handleClickStyle"
          >
            <el-tab-pane label="测评主页" name="cpzy"></el-tab-pane>
            <el-tab-pane label="测评题结果页" name="cpjg"></el-tab-pane>
          </el-tabs>
          <div>
            <div
                class="style-outer"
                v-for="(item, index) in tableDataStyle"
                :key="item.examStyleId"
                @click="selectStyle(item, item.examStyleId)"
            >
              <div class="isCheck">
                <i
                    :class="[
                    'el-icon-success',
                    { active_class: activeIndex == item.examStyleId },
                  ]"
                ></i>
              </div>
              <el-image
                  style="width: 108px; height: 76px"
                  :src="item.icon"
                  fit="cover"
              ></el-image>
              <div class="style__font">{{ item.name }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <operation-confirmation
        @closeOperation="publicMethios"
        :operationVisible="operationVisible"
    ></operation-confirmation>
  </div>
</template>
<script>
import richText from "@/components/richText.vue";

import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {formatMoney} from "@utils/filters/filter";
import {formatMaxNum, formatMinNum, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import {isEmpty} from "@utils/tools";
import OperationConfirmation from "@/components/OperationConfirmation";

export default {
  inject: ["reload"],
  filters: {
    payPrice(num) {
    },
  },
  components: {
    richText,
    OperationConfirmation,
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  data() {
    return {
      activeIndex: -1, //样式激活的index
      /* 这两个样式在哪里的 临时存储 */
      tempStyle: {
        main: -1,
        res: -1,
      },

      // listParams: {},
      params: {
        // vipFree: 0,
        // examId:'BBQM001'
      },
      dictDataSelect: "",
      dictDataSelect1: "",
      selectData: [],
      tableData: [],
      formatMoney,
      formatMaxNum,
      formatMinNum,
      emptyShow,
      dialogVisible: false,
      total: 0,
      PAGE_SIZE,
      loading: false,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      explain: {},
      treeProps: {
        //配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },
      srcList: [],
      isMoer: true,
      srcListLang: [],
      isMoerLang: true,
      srcListVideo: "",
      isMoerVideo: true,
      srcListBanner: [],
      isMoerBanner: true,
      activeName: "",
      dialogVisibleExplain: false,
      innerVisible: false,
      clickType: "",
      explainData: [], //说明列表数据
      explainParams: {},
      explainTypeData: [], //获取说明类型数据
      examInfoId: "",
      dialogVisibleStyle: false,
      tableDataStyle: [],
      listParams: {
        styleType: "cpzy",
      },
      paramsClass: {
        styleType: "cpzy",
      },
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        examId: [{required: false, message: "请填写标识", trigger: "blur"}],
        subject: [{required: true, message: "请填写主题", trigger: "change"}],
        feeDescr: [
          {required: true, message: "请填写有偿说明", trigger: "blur"},
        ],
        payPrice: [
          {required: true, message: "请填写支付价", trigger: "blur"},
        ],
        rawPrice: [{required: true, message: "请填写原价", trigger: "blur"}],
        buys: [{required: true, message: "请填写购买次数", trigger: "blur"}],
        submits: [
          {required: true, message: "请填写取名次数", trigger: "blur"},
        ],
      },
      explainRules: {
        introType: [
          {required: true, message: "请选择说明类型", trigger: "change"},
        ],
        intro: [{required: true, message: "请填写详情", trigger: "change"}],
        // seq: [{
        //   // required: true,
        //  message: "请填写序号", trigger: "change" }],
      },
      flag: false, //销毁子组件
      operationVisible: false,
      numType: false,
      pageLoading: false, // 页面加载loading
      richTextMouted: false,
      navInfoArray: [],// 导航信息

      addShow: false,
      introShow: false,
      styleShow: false,

      intitle_id:"BBQM001"
    };
  },
  created() {
    if(window.sessionStorage.getItem('intitle_id')){
      this.intitle_id = window.sessionStorage.getItem('intitle_id')
    }
    this.classifyData();
    this.getBabyNameDetails();
    this.getNavInfo();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect1 = ""; //清空分类
        /* 以下：清空所有图片  */
        this.srcList = [];
        this.isMoer = true;
        this.srcListLang = [];
        this.isMoerLang = true;
        this.srcListVideo = "";
        this.isMoerVideo = true;
        this.srcListBanner = [];
        this.isMoerBanner = true;
      }
    },
    dialogVisibleStyle() {
      if (this.dialogVisibleStyle == false) {
        this.$refs["ruleStyle"].resetFields();
        this.params = {};
        this.activeIndex = -1; //样式激活的index
        /* 这两个样式在哪里的 临时存储 */
        this.tempStyle = {
          main: -1,
          res: -1,
        };
      }
    },
    intitle_id(){
      this.params = {};
      this.dictDataSelect1 = ""; //清空分类
      /* 以下：清空所有图片  */
      this.srcList = [];
      this.isMoer = true;
      this.srcListLang = [];
      this.isMoerLang = true;
      this.srcListVideo = "";
      this.isMoerVideo = true;
      this.srcListBanner = [];
      this.isMoerBanner = true;
    },
  },
  methods: {
    handleClickTab(){
      this.classifyData();
      this.getBabyNameDetails();
      this.getNavInfo();
    },

    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'guoxue:info:add') {
            this.addShow = true
          }
          if (item.code == "guoxue:info:intro") {
            this.introShow = true
          }
          if (item.code == "guoxue:info:style") {
            this.styleShow = true
          }
        })
      }
    },
    /*
     *@method: getNavInfo
     *@param:  
     *@desc:  获取导航信息
     *@Date: 2021-09-10 17:52:26
    */
    async getNavInfo() {
      const {data: resData} = await this.$get("/intitle/nav/list", {});
      if (resData.result != 200) return;
      if (Array.isArray(resData.data)) {
        this.navInfoArray = resData.data;
      }
    },
    /*
     *@method: getBabyNameDetails
     *@param:
     *@desc:  获取宝宝取名详情
     *@Date: 2021-09-09 18:04:56
     */
    async getBabyNameDetails() {
      this.pageLoading = true;
      this.richTextMouted = false;
      const {data: resData} = await this.$get("/intitle/info/"+this.intitle_id, {});
      this.pageLoading = false;
      if (resData.result != 200) return;
      // console.log(resData.data);
      // this.params=resData.data;
      let temp = resData.data;
      this.srcListLang = []
      this.srcList = []
      if (emptyShow(temp.logo)) {
        this.srcList.push(temp.logo);
        this.isMoer = false;
      }
      if (emptyShow(temp.logo2)) {
        this.srcListLang.push(temp.logo2);
        this.isMoerLang = false;
      }
      if (emptyShow(temp.banners)) {
        this.srcListBanner = temp.banners; //轮播图
        this.isMoerBanner = true;
      }
      if (emptyShow(temp.video)) {
        this.video = temp.video; //视频
        this.isMoerVideo = false;
      }
      let newarr = JSON.parse(JSON.stringify(temp));
      newarr.payPrice = temp.payPrice / 100;
      newarr.rawPrice = temp.rawPrice / 100;
      this.params = newarr;
      this.dictDataSelect1 = temp.categoryName;
      this.richTextMouted = true;
    },

    // 跳转说明设置和样式设置
    jumpNav(type) {
      window.sessionStorage.setItem('intitle_id',this.params.intitleId)
      this.$router.push({
        path: type === "babyMameDesSet" ? "babyMameDesSet" : "babyMameStyleSet",
        query: {
          id: this.params.intitleInfoId,
          uid: this.params.intitleId,
        },
      });
    },
    //清楚缓存数据，重启密码验证
    clearStore() {
      window.sessionStorage.removeItem("operationKey");
      this.numType = false;
    },
    //关闭
    publicMethios(e) {
      this.operationVisible = false;
      if (e == "open") {
        this.numType = true;
        setTimeout(() => {
          window.sessionStorage.removeItem("operationKey");
          this.numType = false;
        }, 1800000);
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true;
    },
    SearchQuestionBankList() {
      this.pages.pageNo = 1;
      this.queryTableData();
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("/exam/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      let list = resData.data;
      // list.forEach((item,index)=>{
      //   item.payPrice = item.payPrice/100
      //   item.rawPrice = item.rawPrice/100
      // })
      this.tableData = list;
      this.total = resData.page.count;
    },
    /**
     * 获取分类列表
     */
    async classifyData() {
      this.loading = true;

      const {data: resData} = await this.$get("/exam/category/list", {
        params: {
          status: 1,
          paging: false,
          tree: true,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.selectData = resData.data.sort(function (a, b) {
        return b.seq - a.seq;
      });
    },
    /**
     * 获取说明类型
     */
    async explainType() {
      this.loading = true;
      const {data: resData} = await this.$get(`/enums/list/EXAM_INTRO_TYPE`);
      this.loading = false;
      if (resData.result != 200) return;
      this.explainTypeData = resData.data;
      this.activeName = resData.data[0].enumVal;
    },
    /**
     * 获取评测说明列表
     */
    async explainTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("/exam/intro/list", {
        params: {
          ...this.explain,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.explainData = resData.data.sort(function (a, b) {
          return b.seq - a.seq;
        });
      } else {
        this.explainData = resData.data;
      }
    },

    /**
     * 修改评测题库状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `/exam/info/status/${b.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.listParams.categoryId = node.categoryId;
      if (node.parentId == 0) {
        this.listParams.parentId = node.categoryId;
      } else {
        this.listParams.parentId = node.categoryId;
      }
      if (node.id != 0) {
        //this.AccountData.orgId = node.id;
      }
      this.$refs.selectReport.blur();
    },
    handleNodeClick1: function (node) {
      this.dictDataSelect1 = node.name;
      this.params.categoryId = node.categoryId;
      this.$refs.selectReport.blur();
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.logo = this.srcList[0];
    },

    getPolicyLang() {
      this.$refs.fileLang.dispatchEvent(new MouseEvent("click"));
    },
    async getFileLang() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileLang.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListLang
      );
      this.isMoerLang = false;
      this.srcListLang = addRoutes;
      this.params.logo2 = this.srcListLang[0];
    },

    getPolicyVideo() {
      this.$refs.fileVideo.dispatchEvent(new MouseEvent("click"));
    },
    async getFileVideo() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileVideo.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListVideo
      );
      this.isMoerVideo = false;
      this.srcListVideo = addRoutes;

      this.params.video = this.srcListVideo[0];
    },

    getPolicyBanner() {
      this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
    },
    async getFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListBanner
      );
      this.isMoerBanner = false;
      this.srcListBanner = addRoutes;

      this.params.banners = this.srcListBanner;
    },
    removeUploading(index) {
      this.srcListBanner.splice(index, 1);
      this.params.banners = this.srcListBanner;
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.explainParams = {};
      if (type == "edit") {
        this.srcListLang = [];
        this.srcList = [];
        this.isMoer = true;
        this.isMoerLang = true;
        this.$get(`/exam/info/${row.examId}`).then((res) => {
          let temp = res.data.data;
          if (emptyShow(temp.logo)) {
            this.srcList.push(temp.logo);
            this.isMoer = false;
          }
          if (emptyShow(temp.logo2)) {
            this.srcListLang.push(temp.logo2);
            this.isMoerLang = false;
          }
          if (emptyShow(temp.banners)) {
            this.srcListBanner = temp.banners; //轮播图
            this.isMoerBanner = true;
          }
          if (emptyShow(temp.video)) {
            this.video = temp.video; //视频
            this.isMoerVideo = false;
          }

          this.flag = false;
          this.$nextTick(() => {
            this.flag = true; //组件生命重新加载
          });

          let newarr = JSON.parse(JSON.stringify(temp));

          newarr.payPrice = temp.payPrice / 100;
          newarr.rawPrice = temp.rawPrice / 100;

          this.params = newarr;
          this.dictDataSelect1 = temp.categoryName;
        });
        this.dialogVisible = true; //编辑
      } else if (type == "add") {
        row.vipFree = 1;
        row.recomVip = 1;
        row.resultStatus = 1;

        this.flag = false;
        this.$nextTick(() => {
          this.flag = true; //组件生命重新加载
        });
        this.params = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      } else if (type == "explain") {
        this.dialogVisibleExplain = true;
        this.examInfoId = row.examInfoId;

        /* 获取  第一项 */
        this.explainType();
        this.explain.introType = this.explainTypeData[0].enumVal;
        this.explain.examInfoId = this.examInfoId;
        this.explainTableData();
      } else if (type == "explainAdd") {
        this.explainParams.intro = "";
        this.explainParams = {};
        setTimeout(() => {
          this.innerVisible = true;
        }, 500);
      } else if (type == "explainEdit") {
        const {data: resData} = await this.$get(
            `/exam/intro/info/${row.examIntroId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        this.explainParams = resData.data;
        this.innerVisible = true;
      } else if (type == "style") {
        this.dialogVisibleStyle = true;
        this.paramsClass.class = row.categoryName;
        this.paramsClass.name = row.name;
        this.paramsClass.iden = row.examId;
        this.appraisalStyle(); /* 已经关联的样式 */
      } else if (type == "topic") {
        if (row.scheme == "jz") {
          this.$router.push({
            name: "JZ_LIST",
            query: {
              examId: row.examId,
            },
          });
        } else {
          this.$router.push({
            name: "WD_LIST",
            query: {
              examId: row.examId,
            },
          });
        }
      } else if (type == "time") {
        this.$confirm("确定对当前时间进行操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              const {data: resData} = this.$put(
                  `/exam/info/issued/time/${row.examId}`,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );

              if (resData.result != 200) return;
              this.queryTableData(); ///RENEW
              this.$message.success(resData.message);
            })
            .catch(() => {
            });
      }
    },

    /**
     * 编辑/新增
     */
    handleEdit() {
      let b = this.params.payPrice * 100;
      let c = b.toFixed(1);
      let rawb = this.params.rawPrice * 100;
      let rawc = rawb.toFixed(1);
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.payPrice = parseInt(c);
          this.params.rawPrice = parseInt(rawc);
          const {data: resData} = await this.$put(
              "/intitle/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );

          if (resData.result != 200) return;

          this.$message.success("操作成功!");

          this.getBabyNameDetails()
        });
      });
    },
    /**
     * 说明编辑/新增
     */
    handleExplainEdit() {
      // explainParams.intro
      this.$refs.explainRuleForm.validate((valid) => {
        if (!valid) return;
        if (this.explainParams.seq) {
          this.explainParams.examInfoId = this.examInfoId;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            if (this.clickType == "explainAdd") {
              const {data: resData} = await this.$post(
                  "/exam/intro/info",
                  this.explainParams,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );

              if (resData.result != 200) return;

              this.explainTableData();

              this.innerVisible = false;

              this.$message.success("添加成功!");
              this.explainParams = {};
            }
            if (this.clickType == "explainEdit") {
              this.explainParams.examInfoId = this.examInfoId;
              const {data: resData} = await this.$put(
                  "/exam/intro/info",
                  this.explainParams,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );

              if (resData.result != 200) return;

              this.explainTableData();

              this.innerVisible = false;

              this.$message.success("修改成功!");
            }
          });
        } else {
          this.$message.success("请填写排序");
        }
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/info/${row.examId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryTableData();
        this.$message.success("删除成功!");
      });
      this.clearStore();
    },
    /**
     * 说明删除
     */
    handleDeleteexplain(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/intro/info/${row.examIntroId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.explainTableData();

        this.$message.success("删除成功!");
      });
      this.clearStore();
    },

    handleClickExplain(tab, event) {
      this.explain.introType = tab.name;
      this.explainTableData();
    },

    // 获取已经关联样式id
    async queryStyleData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/style/list", {
        params: {
          ...this.listParams,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableDataStyle = resData.data.sort(function (a, b) {
        return b.seq - a.seq;
      });
    },

    /*左右 切换样式 */
    handleClickStyle(tab, event) {
      this.activeIndex =
          tab.name == "cpzy" ? this.tempStyle.main : this.tempStyle.res; //相应切换到 index
      this.listParams.styleType = tab.name;
      this.listParams.examId = this.paramsClass.iden;
      // this.explainType();

      this.appraisalStyle();
      this.queryStyleData(); /* 已经关联的样式 */
    },

    /* 点击下面的样式 */
    selectStyle(item, index) {
      var that = this;
      // 将点击的是谁 存起来
      if (this.paramsClass.styleType == "cpzy") {
        this.tempStyle.main = index;
        this.activeIndex = this.tempStyle.main;
      } else {
        this.tempStyle.res = index;
        this.activeIndex = this.tempStyle.res;
      }

      item.examId = this.paramsClass.iden;
      /* 关联样式 */
      this.$post("/exam/info/style", {
        examId: item.examId,
        examStyleId: item.examStyleId,
        styleType: this.paramsClass.styleType,
      }).then((res) => {
        if (res.data.result == 200) {
          that.$message.success("关联成功");
        } else {
          that.$message.warning(res.message);
        }
      });
    },

    /**
     * 获取  打开弹窗 关联的 测评样式
     */
    async appraisalStyle() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `/exam/info/style/${this.paramsClass.iden}/${this.paramsClass.styleType}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data == undefined) return;

      if (this.paramsClass.styleType == "cpzy") {
        this.tempStyle.main = resData.data.examStyleId;
      } else {
        this.tempStyle.res = resData.data.examStyleId;
      }
      this.activeIndex = resData.data.examStyleId;
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.babyName-set-content {
  background: #ffffff;
  padding:0 40% 20px 0;

  .contorl-btn {
    padding-left: 80px;
  }
}

.diplay {
  display: inline-block;
}

.screenshot {
  display: inline-block;
  vertical-align: text-top;
}

.video-label {
  margin-right: 15px;
}

.item-add {
  margin: 15px 0;

  .el-button {
    margin-bottom: 15px;
  }

  .el-button img {
    max-height: 12px;
  }
}

.style-outer {
  background: #fff;
  float: left;
  margin: 0 20px 20px 0;
  width: 108px;
  height: 110px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;

  .style__font {
    line-height: 5px;
    margin: 0 0 0 10px;
  }

  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;

    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.active_class {
  // border: 1px solid #000 !important;
  color: #67c23a !important;
}
</style>
<style>
.content .el-tabs__nav-wrap{
  width:800px !important;
}
.content .el-tabs__nav{
  width: 100% !important;
}
.content .el-tabs__item {
  width: 14.2%;
  padding: 0 !important;
  text-align: center;
  font-weight: 600;
}
.content .el-tabs__active-bar{
  height: 1px !important;
}
.content .el-tabs__nav-wrap::after{
  height: 1px !important;
}
/*.content .el-tabs__nav-scroll{*/
/*  width: 270px !important;*/
/*}*/
</style>
